// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__2mzdQ","selectedCategory":"Breadcrumbs_selectedCategory__2Pssj"};